var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-item',{attrs:{"route":"Request","params":{ request: _vm.request.id }}},[_c('app-item-title',{attrs:{"text":_vm.$highlight(_vm.request.term, _vm.highlight),"subtitle":_vm._f("formatDate")(_vm.request.date,'h:mma, MMMM Do YYYY')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }